import React, { useRef } from 'react';
import { useHover } from 'react-use';
import { useStore } from 'effector-react';
import ScrollbarsHorizontal, {
  type HScrollbarHanlders,
} from '@components/ScrollbarsHorizontal';
import IconArrow from '@components/icons/IconArrow';
import { $sandTable } from '@stores/dataStores';
import SandTableItem from './SandTableItem';

function SandeTableList() {
  const scrollRef = useRef<HScrollbarHanlders>(null);
  const list = useStore($sandTable);

  const [leftArrow] = useHover((isHovered) => (
    <div
      className="mr-10 flex h-full w-16 cursor-pointer items-center rounded bg-black-#34"
      onClick={() => scrollRef.current?.scrollLeft()}
    >
      <IconArrow className="rotate-90 transform" active={isHovered} />
    </div>
  ));

  const [rightArrow] = useHover((isHovered) => (
    <div
      className="ml-10 flex h-full w-16 cursor-pointer items-center rounded bg-black-#34"
      onClick={() => scrollRef.current?.scrollRight()}
    >
      <IconArrow className="-rotate-90 transform" active={isHovered} />
    </div>
  ));

  return (
    <div className="mt-auto flex h-80 items-center">
      {leftArrow}
      <div className="flex h-full flex-grow items-center">
        <ScrollbarsHorizontal ref={scrollRef} autoHide={false}>
          <div className="-ml-10 flex items-center">
            {list.map((x, i) => (
              <SandTableItem key={x.id} data={x} index={i} />
            ))}
          </div>
        </ScrollbarsHorizontal>
      </div>
      {rightArrow}
    </div>
  );
}

export default SandeTableList;
